<div class="flex bg-gray-50" style="height: calc(100vh - 130px); width: calc(85vw - 130px)">
    <!-- Left Panel: Dialog List -->
    <div class="w-1/4 border border-gray-200 bg-white p-4 flex flex-col rounded-2xl">
        <h2 class="text-xl font-semibold mb-4">My Chats</h2>

        <button class="py-2 px-3 mt-2 w-full text-white rounded-lg bg-brand-500 text-theme-sm hover:bg-brand-600"
                (click)="addNewChat()">
            + New Chat
        </button>

        <div class="space-y-2 overflow-y-auto flex-1 mt-4">
            <div *ngFor="let dialog of dialogs"
                 class="p-3 rounded-xl cursor-pointer hover:bg-gray-100 flex justify-between items-center relative"
                 [class.bg-gray-200]="dialog.id === selectedDialogId">

                <!-- Clickable title area -->
                <div class="flex-1 min-w-0 flex items-center" (click)="selectDialog(dialog.id)">
                    <div class="w-[90%] min-w-0">
                        <p class="font-medium truncate">{{ dialog.title }}</p>
                        <p class="text-sm text-gray-500 truncate">{{ dialog.lastMessage }}</p>
                    </div>
                </div>

                <!-- Dropdown menu -->
                <div class="relative inline-block">
                    <button class="dropdown-toggle" (click)="toggleMenu(dialog.id, $event)">
                        <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                             class="text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 size-6">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z"
                                  fill="currentColor"></path>
                        </svg>
                    </button>

                    <app-dropdown [isOpen]="openMenuId === dialog.id" (close)="closeDropdown()" [placement]="'down'" className="w-40 p-2">
                        <app-dropdown-item (itemClick)="openRenamePopup(dialog.id)"
                                           className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300">
                            Rename
                        </app-dropdown-item>
                        <app-dropdown-item (itemClick)="deleteDialog(dialog.id)"
                                           className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300">
                            Delete
                        </app-dropdown-item>
                    </app-dropdown>
                </div>

                <app-popup [visible]="showRenamePopup" (close)="handleRenameCancel()">
                    <h2 class="text-xl font-semibold mb-4 text-center">Rename Chat</h2>
                    <app-input-field type="text" [(ngModel)]="renameDialogTitle" placeholder="Enter new chat name" />
                    <div class="flex gap-4 justify-end mt-4">
                        <app-button size="sm" variant="outline" (click)="handleRenameCancel()">Cancel</app-button>
                        <app-button size="sm" variant="primary" (click)="handleRenameSave(renameDialogTitle)">Save</app-button>
                    </div>
                </app-popup>
            </div>
        </div>
    </div>

    <!-- Right Panel: Chat Window -->
    <div class="flex-1 flex flex-col">
        <div class="flex-1 overflow-y-auto p-6 space-y-4" style="height: calc(100vh - 80px)">
            <ng-container *ngIf="homeMode; else chatWindow">
                <div class="flex justify-center items-center h-full text-gray-400 text-lg">
                    💬 How can I help you?
                </div>
            </ng-container>

            <ng-template #chatWindow>
                <div *ngFor="let message of messages"
                     class="flex"
                     [ngClass]="message.sender === 'user' ? 'justify-end' : 'justify-start'">
                    <div class="markdown-content max-w-md px-4 py-2 rounded-2xl shadow text-sm break-words"
                         [ngClass]="message.sender === 'user' ? 'bg-blue-500 text-white rounded-br-none' : 'bg-gray-200 text-gray-900 rounded-bl-none'">
                        <ng-container *ngIf="message.sender === 'ai' && isLoading && !message.text; else normalMessage">
                            <span class="typing-dots">
                                <span></span>
                                <span></span>
                                <span></span>
                            </span>
                        </ng-container>
                        <ng-template #normalMessage>
                            <div [innerHTML]="message.text | markdown | safeHtml"></div>
                        </ng-template>
                    </div>
                </div>
            </ng-template>
        </div>

        <!-- Input Box -->
        <div class="sticky bottom-0 border border-gray-200 rounded-2xl ml-2 p-4 flex items-center bg-white gap-2">
            <!-- Models Dropdown -->
            <div class="relative inline-block">
                <button class="px-3 py-2 border border-gray-200 rounded-xl text-sm text-gray-700 hover:bg-gray-50 w-56 flex items-center justify-between"
                        (click)="toggleModelDropdown($event)">
                    <span class="truncate">{{ selectedModel || 'Select model' }}</span>
                    <!-- Persistent caret arrow -->
                    <svg class="ml-2 h-4 w-4 text-gray-500 transform transition-transform duration-200" [ngClass]="{ 'rotate-180': modelDropdownOpen }" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" clip-rule="evenodd" />
                    </svg>
                </button>
                <app-dropdown [isOpen]="modelDropdownOpen" (close)="closeDropdown()" [placement]="'up'" [showArrow]="false" className="w-56 p-2 max-h-64 overflow-auto">
                    <ng-container *ngIf="installedModels.length; else noModels">
                        <app-dropdown-item *ngFor="let m of installedModels" (itemClick)="selectModel(m)"
                                           className="flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800">
                            {{ m }}
                        </app-dropdown-item>
                    </ng-container>
                    <ng-template #noModels>
                        <div class="px-2 py-1 text-sm text-gray-400">No models found</div>
                    </ng-template>
                </app-dropdown>
            </div>

            <input type="text"
                   [(ngModel)]="newMessage"
                   (keyup.enter)="sendMessage()"
                   placeholder="Type a message..."
                   class="flex-1 border border-gray-200 rounded-xl px-4 py-2 focus:outline-none focus:ring focus:ring-blue-200">
            <button (click)="sendMessage()"
                    class="px-4 py-2 text-white rounded-lg bg-brand-500 text-theme-sm hover:bg-brand-600">
                Send
            </button>
        </div>
    </div>
</div>
